__turbopack_context__.v({
  "className": "montserrat_4998070-module__ELtfBG__className",
});
